import React from 'react';
import PropTypes from 'prop-types';

const MarketActionApplication = ({ applicationProperty }) => {
  if (!applicationProperty) return null;

  return (
    <dl className="ma-brief-item">
      <dt className="market-action-list__dt">Application:</dt>
      <dd className="market-action-list__dd">{applicationProperty}</dd>
    </dl>
  );
};

MarketActionApplication.propTypes = {
  applicationProperty: PropTypes.string,
};

export default MarketActionApplication;
